import React from "react";
import { Row, Col, Input, Label } from "reactstrap";
import { ChevronLeft, ChevronRight } from "react-feather";

/**
 * SitesPagination - Pagination component for sites view
 */
const SitesPagination = ({ pagination, onPageChange, onPageSizeChange }) => {
  const { currentPage, pageSize, totalPages, totalElements } = pagination;

  const handlePrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageSizeChange = (e) => {
    onPageSizeChange(Number(e.target.value));
  };

  return (
    <div className="sites-pagination mt-3 p-3 border rounded">
      <Row className="align-items-center">
        <Col md="6">
          <div className="d-flex align-items-center gap-3">
            <span className="text-muted">
              Showing {currentPage * pageSize + 1} to{" "}
              {Math.min((currentPage + 1) * pageSize, totalElements)} of {totalElements} entries
            </span>
          </div>
        </Col>
        <Col md="6">
          <div className="d-flex justify-content-end align-items-center gap-3">
            <div className="d-flex align-items-center gap-2">
              <Label for="pageSize" className="mb-0 text-nowrap">
                Rows per page:
              </Label>
              <Input
                id="pageSize"
                type="select"
                value={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: "80px" }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </Input>
            </div>
            <div className="d-flex align-items-center gap-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={handlePrevious}
                disabled={currentPage === 0}
              >
                <ChevronLeft size={16} />
              </button>
              <span className="text-muted">
                Page {currentPage + 1} of {totalPages || 1}
              </span>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={handleNext}
                disabled={currentPage >= totalPages - 1}
              >
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SitesPagination;
